<kendo-combobox [data]="displayData" textField="templateName" valueField="batchTemplateId"
  placeholder="{{ 'Operative.SearchBatchTemplate' | translate }}" [loading]="loading" [value]="selectedbatchTemplateId"
  [filterable]="true" [valuePrimitive]="true" (filterChange)="handleFilter($event)"
  (valueChange)="onChangedVal($event)">
  <ng-template kendoComboBoxGroupTemplate let-groupName>
    {{ groupName }}
  </ng-template>
</kendo-combobox>